import { useRef, useEffect, useContext } from "react";
import Chart from "chart.js/auto";
import { Spin } from "antd";
import { STATUS } from "../../constants";
import { memo } from "react";
import { UserContext } from "../../context";

const Chart14 = memo(({ kanbanFilterInfo, status }) => {
  const { parkId } = useContext(UserContext);
  const element = useRef();
  const filterDataReg = kanbanFilterInfo.filter((item) => item.cloumn === 32);
  const filterDataApl = kanbanFilterInfo.filter((item) => item.cloumn === 31);
  const allyear = Array.from(
    { length: 5 },
    (_, index) => new Date().getFullYear() - 4 + index
  );
  useEffect(() => {
    let RegDatas = [];
    let AplDatas = [];
    if (filterDataReg.length > 0 && filterDataApl.length > 0) {
      const datas = filterDataReg[0].context
        .filter((item) => allyear.includes(Number.parseInt(item.year)))
        .sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year));

      RegDatas = allyear.map((year) => {
        const item = datas.find((obj) => obj.year === year.toString());
        return item ? item.count : 0;
      });
      const datasTwo = filterDataApl[0].context
        .filter((item) => allyear.includes(Number.parseInt(item.year)))
        .sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year));

      AplDatas = allyear.map((year) => {
        const item = datasTwo.find((obj) => obj.year === year.toString());
        return item ? item.count : 0;
      });
    }

    const chart = new Chart(element.current, {
      type: "line",
      data: {
        labels: allyear,
        datasets: [
          {
            label: "申请数量",
            data: parkId === 69 ? [150, 290, 400, 520, 591] : AplDatas,
            fill: true,
            borderColor: "#264653",
          },
          {
            label: "注册数量",
            data: parkId === 69 ? [113, 235, 357, 502, 580] : RegDatas,
            fill: true,
            borderColor: "#e76f51",
          },
        ],
      },
      options: {
        scales: {
          y: {
            min: 0,
            // max: 30,
            // ticks: { stepSize: 1 }
          },
        },
        aspectRatio: 1.5,
        layout: {
          // padding: 16
        },
        plugins: {
          legend: { position: "bottom" },
        },
      },
    });
    return () => chart.destroy();
  }, [filterDataReg, filterDataApl, allyear]);
  return (
    <Spin spinning={status === STATUS.idle}>
      <canvas ref={element} />
    </Spin>
  );
});

export default Chart14;
